// Shared form shape for the Register flow, extracted so every section component
// (company / personal / credentials / terms) and the parent orchestrator agree on
// exactly one type. Mirrors `registerValidationSchema` (utils/validations.ts) field
// for field.
export type RegisterFormValues = {
  companyName: string;
  commercialName: string;
  firstName: string;
  lastName: string;
  email: string;
  confirmEmail: string;
  phone: string;
  taxId: string;
  country: string;
  age: boolean;
  password: string;
  confirmPassword: string;
  termsAndConditions: boolean;
  informationAgreement: boolean;
  invitationCode: string;
};

/**
 * Explicit `defaultValues` so every `Controller`-bound field starts DEFINED — the
 * Task-6 (login) precedent: a Controller field with no default is `undefined`, and
 * Yup's per-field tests (`.matches`, `.min`, `.email`, `.oneOf`) skip `undefined`
 * and defer to `.required()`. Seeding `""`/`false` keeps Yup's error selection
 * identical to the pre-Carbon `register()` form (whose native inputs defaulted to
 * `""`), which is what e2e/unauthenticated.spec.ts pins.
 *
 * `informationAgreement` starts `true` — the pre-Carbon form's local `useState(true)`
 * default (the marketing opt-in is pre-checked; it is `.notRequired()` in the schema).
 */
export const registerDefaultValues: RegisterFormValues = {
  companyName: "",
  commercialName: "",
  firstName: "",
  lastName: "",
  email: "",
  confirmEmail: "",
  phone: "",
  taxId: "",
  country: "",
  age: false,
  password: "",
  confirmPassword: "",
  termsAndConditions: false,
  informationAgreement: true,
  invitationCode: "",
};

/** The `{status, data}` shape the signup response is stored as and `Success` reads.
 * `data` carries the Task-3 signup DTO (`UserDetailResponse`) fields — kept optional
 * so `Success` stays defensive if the backend omits one. */
export type SignUpResponse = {
  status: number;
  data: {
    firstName?: string;
    lastName?: string;
    fullName?: string;
  };
};
